"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InputTags;
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _Chip = _interopRequireDefault(require("@mui/material/Chip/Chip.js"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton/IconButton.js"));
var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment/InputAdornment.js"));
var _Stack = _interopRequireDefault(require("@mui/material/Stack/Stack.js"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField/TextField.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Tags = ({
  data,
  handleDelete
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    sx: {
      paddingRight: '0.4rem',
      paddingBottom: '0.4rem'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack.default, {
      direction: "row",
      gap: 1,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.default, {
        label: data,
        size: "small",
        onDelete: () => handleDelete(data)
      })
    })
  });
};
function InputTags({
  values,
  onChange,
  limitTags = -1
}) {
  const [tags, setTags] = (0, _react.useState)([]);
  const tagRef = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    setTags(values.filter(val => !!val));
  }, [values]);
  const handleDelete = value => {
    const newtags = tags.filter(val => val !== value);
    setTags(newtags);
    onChange?.(newtags);
  };
  const clearAllTags = () => {
    setTags([]);
    onChange?.([]);
  };
  const handleOnSubmit = e => {
    e.preventDefault();
    if (tagRef?.current) {
      //@ts-ignore
      const newTags = [...tags, tagRef.current.value];
      setTags(newTags);
      onChange?.(newTags);
      //@ts-ignore
      tagRef.current.value = '';
    }
  };
  const handleOnBlur = () => {
    //@ts-ignore
    if (tagRef?.current?.value) {
      //@ts-ignore
      const newTags = [...tags, tagRef.current.value];
      setTags(newTags);
      onChange?.(newTags);
      //@ts-ignore
      tagRef.current.value = '';
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    sx: {
      flexGrow: 1
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
      onSubmit: handleOnSubmit,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
        inputRef: tagRef,
        fullWidth: true,
        variant: "standard",
        onBlur: handleOnBlur,
        sx: {
          '& .MuiInputBase-root': {
            flexWrap: 'wrap'
          },
          '& .MuiInput-input': {
            minWidth: '30px',
            width: 0,
            '-webkit-box-flex': 1,
            flexGrow: 1,
            textOverflow: 'ellipsis'
          }
        },
        size: "small",
        margin: "none",
        placeholder: "Enter values...",
        InputProps: {
          startAdornment: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [(limitTags > 0 ? tags.slice(0, limitTags) : tags).map((data, index) => {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(Tags, {
                data: data,
                handleDelete: handleDelete
              }, index);
            }), limitTags > 0 && tags.length > limitTags && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.default, {
              sx: {
                paddingRight: '0.4rem',
                paddingBottom: '0.3rem',
                fontSize: '0.75rem'
              },
              variant: "caption",
              children: ["+", tags.length - limitTags]
            })]
          }),
          endAdornment: tags.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAdornment.default, {
            position: "end",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
              "aria-label": "reset value",
              onClick: clearAllTags,
              edge: "end",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Close.default, {})
            })
          })
        }
      })
    })
  });
}